import type { FacilityReportBranding, LetterheadLayout, SignatureLayout } from '../../../types/facility.type'

export const DEFAULT_LETTERHEAD_LAYOUT: LetterheadLayout = 'logo_left'
export const DEFAULT_SIGNATURE_LAYOUT: SignatureLayout = 'right'

const LETTERHEAD_LAYOUTS: LetterheadLayout[] = ['logo_left', 'logo_right', 'stacked']
const SIGNATURE_LAYOUTS: SignatureLayout[] = ['left', 'right', 'center']

function isLetterheadLayout(value: unknown): value is LetterheadLayout {
  return typeof value === 'string' && LETTERHEAD_LAYOUTS.includes(value as LetterheadLayout)
}

function isSignatureLayout(value: unknown): value is SignatureLayout {
  return typeof value === 'string' && SIGNATURE_LAYOUTS.includes(value as SignatureLayout)
}

export function normalizeReportBranding(
  branding?: Partial<FacilityReportBranding> | null
): Required<FacilityReportBranding> {
  return {
    letterhead_layout: isLetterheadLayout(branding?.letterhead_layout)
      ? branding.letterhead_layout
      : DEFAULT_LETTERHEAD_LAYOUT,
    signature_layout: isSignatureLayout(branding?.signature_layout)
      ? branding.signature_layout
      : DEFAULT_SIGNATURE_LAYOUT
  }
}

/** Prefer snapshotted result branding; then template branding; then facility; then defaults. */
export function resolveReportLayouts(opts: {
  documentBranding?: Partial<FacilityReportBranding> | null
  templateBranding?: Partial<FacilityReportBranding> | null
  facilityBranding?: Partial<FacilityReportBranding> | null
}): Required<FacilityReportBranding> {
  if (opts.documentBranding) return normalizeReportBranding(opts.documentBranding)
  if (opts.templateBranding) return normalizeReportBranding(opts.templateBranding)
  return normalizeReportBranding(opts.facilityBranding)
}
